(() => {
  const qs = (selector, context = document) => context.querySelector(selector);
  const qsa = (selector, context = document) => [...context.querySelectorAll(selector)];
  const cartRoot = () => window.Shopify?.routes?.root || '/';

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-mm-menu-open]');
    const close = event.target.closest('[data-mm-menu-close]');
    const drawer = qs('[data-mm-mobile-drawer]');

    if (open && drawer) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    if (close && drawer) {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    const dot = event.target.closest('[data-mm-hero-dot]');
    if (dot) {
      activateSlide(dot.closest('[data-mm-hero]'), Number(dot.dataset.mmHeroDot));
    }

    const thumb = event.target.closest('[data-mm-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-mm-gallery]');
      const index = Number(thumb.dataset.mmThumb);
      qsa('[data-mm-thumb]', gallery).forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
      qsa('[data-mm-main-image]', gallery).forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === index));
    }

    const option = event.target.closest('[data-mm-option]');
    if (option) selectOption(option);

    const quantityButton = event.target.closest('[data-mm-qty-action]');
    if (quantityButton) {
      const wrapper = quantityButton.closest('[data-mm-qty]');
      const input = qs('input[name="quantity"]', wrapper);
      if (input) {
        const quantity = Math.max(1, Number(input.value || 1) + (quantityButton.dataset.mmQtyAction === 'plus' ? 1 : -1));
        input.value = quantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        syncSticky(wrapper.closest('[data-mm-product]'));
      }
    }

    const stickyButton = event.target.closest('[data-mm-sticky-submit]');
    if (stickyButton) {
      const product = stickyButton.closest('[data-mm-product]');
      qs('[data-mm-main-form] form', product)?.requestSubmit();
    }

    const buyNowButton = event.target.closest('[data-mm-buy-now]');
    if (buyNowButton) handleBuyNow(buyNowButton);

    const sizeChartOpen = event.target.closest('[data-mm-size-chart-open]');
    if (sizeChartOpen) {
      const dialogId = sizeChartOpen.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : qs('[data-mm-size-chart-dialog]', sizeChartOpen.closest('[data-mm-product]'));
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      }
    }

    const sizeChartClose = event.target.closest('[data-mm-size-chart-close]');
    if (sizeChartClose) {
      const dialog = sizeChartClose.closest('[data-mm-size-chart-dialog]');
      dialog?.close();
    }

    const sizeChartDialog = event.target.closest('[data-mm-size-chart-dialog]');
    if (sizeChartDialog && event.target === sizeChartDialog) sizeChartDialog.close();
  });

  function activateSlide(hero, index) {
    if (!hero) return;
    const slides = qsa('[data-mm-hero-slide]', hero);
    const dots = qsa('[data-mm-hero-dot]', hero);
    if (!slides.length) return;
    const safeIndex = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === safeIndex));
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === safeIndex));
    hero.dataset.mmIndex = String(safeIndex);
  }

  function initialiseHeroes(context = document) {
    qsa('[data-mm-hero]', context).forEach((hero) => {
      if (hero.dataset.mmInitialised === 'true') return;
      hero.dataset.mmInitialised = 'true';
      const slides = qsa('[data-mm-hero-slide]', hero);
      if (slides.length > 1) {
        window.setInterval(() => activateSlide(hero, Number(hero.dataset.mmIndex || 0) + 1), 5000);
      }
    });
  }

  function getProductJson(root) {
    try {
      return JSON.parse(qs('[data-mm-product-json]', root)?.textContent || '{}');
    } catch (_error) {
      return {};
    }
  }

  function selectOption(button) {
    const root = button.closest('[data-mm-product]');
    const group = button.closest('[data-mm-option-group]');
    qsa('[data-mm-option]', group).forEach((item) => item.classList.remove('is-selected'));
    button.classList.add('is-selected');

    const label = qs('.mm-option__head b', group);
    if (label) label.textContent = button.dataset.value;

    const selected = qsa('[data-mm-option].is-selected', root).map((item) => item.dataset.value);
    const data = getProductJson(root);
    const variant = (data.variants || []).find((item) => item.options.every((option, index) => option === selected[index]));
    if (!variant) return;

    qsa('input[name="id"]', root).forEach((input) => {
      input.value = variant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const price = qs('[data-mm-price]', root);
    const compare = qs('[data-mm-compare]', root);
    const save = qs('[data-mm-save]', root);
    const addToCart = qs('[data-mm-atc]', root);
    const buyNow = qs('[data-mm-buy-now]', root);

    if (price) price.textContent = money(variant.price, data.money_format);
    if (compare) {
      compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price, data.money_format) : '';
      compare.hidden = !(variant.compare_at_price > variant.price);
    }
    if (save) {
      const percentage = variant.compare_at_price > variant.price
        ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
        : 0;
      save.textContent = percentage ? `Save ${percentage}%` : '';
      save.hidden = !percentage;
    }
    if (addToCart) {
      addToCart.disabled = !variant.available;
      addToCart.textContent = variant.available ? 'Add to cart' : 'Sold out';
    }
    if (buyNow) buyNow.disabled = !variant.available;

    const featuredMediaId = variant.featured_media_id || variant.featured_media?.id || variant.featured_image?.id;
    if (featuredMediaId) qs(`[data-media-id="${featuredMediaId}"]`, root)?.click();
    syncSticky(root);
  }

  function money(cents, format) {
    const amount = (Number(cents) / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    return (format || 'Rs. {{amount}}')
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(Number(cents) / 100).toLocaleString());
  }

  function syncSticky(root) {
    if (!root) return;
    const price = qs('[data-mm-price]', root)?.textContent || '';
    const stickyPrice = qs('[data-mm-sticky-price]', root);
    if (stickyPrice) stickyPrice.textContent = price;
    const mainQuantity = qs('[data-mm-main-form] input[name="quantity"]', root);
    const hiddenQuantity = qs('[data-mm-sticky-quantity]', root);
    if (mainQuantity && hiddenQuantity) hiddenQuantity.value = mainQuantity.value;
  }

  async function handleBuyNow(button) {
    if (button.disabled || button.dataset.loading === 'true') return;
    const form = button.closest('form');
    const errorBox = form ? qs('[data-mm-buy-now-error]', form) : null;
    const label = qs('[data-mm-buy-now-label]', button);
    if (!form) return;

    button.dataset.loading = 'true';
    button.disabled = true;
    if (label) label.textContent = 'Taking you to checkout…';
    if (errorBox) {
      errorBox.hidden = true;
      errorBox.textContent = '';
    }

    try {
      const response = await fetch(`${cartRoot()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');
      window.location.assign(`${cartRoot()}checkout`);
    } catch (error) {
      if (errorBox) {
        errorBox.textContent = error instanceof Error ? error.message : 'Unable to continue to checkout.';
        errorBox.hidden = false;
      }
      button.disabled = false;
      button.dataset.loading = 'false';
      if (label) label.textContent = 'Buy it now';
    }
  }

  function renderCartCount(value) {
    const count = Math.max(0, Number(value) || 0);
    const text = count > 99 ? '99+' : String(count);

    qsa('[data-mm-cart-count]').forEach((counter) => {
      counter.textContent = text;
      counter.classList.toggle('hidden', count === 0);
      const bubble = counter.closest('.cart-bubble');
      bubble?.classList.toggle('visually-hidden', count === 0);
      counter.closest('cart-icon')?.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });

    qsa('[data-mm-cart-drawer-count]').forEach((counter) => {
      counter.textContent = text;
      counter.classList.toggle('visually-hidden', count === 0);
    });

    qsa('[data-mm-cart-label]').forEach((element) => {
      element.setAttribute('aria-label', count === 0 ? 'Cart' : `Cart, ${count} ${count === 1 ? 'item' : 'items'}`);
    });

    try {
      sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() }));
    } catch (_error) {
      // Storage can be blocked in private browsing; the visual count still works.
    }
  }

  let cartSyncTimer;
  function queueCartSync(delay = 120) {
    window.clearTimeout(cartSyncTimer);
    cartSyncTimer = window.setTimeout(syncCartCount, delay);
  }

  async function syncCartCount() {
    try {
      const response = await fetch(`${cartRoot()}cart.js`, {
        headers: { Accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return;
      const cart = await response.json();
      renderCartCount(cart.item_count);
    } catch (_error) {
      // Native Horizon cart events remain the primary update path.
    }
  }

  function handleCartLinesUpdate(event) {
    const promise = event.promise;
    if (promise && typeof promise.then === 'function') {
      promise
        .then(({ cart, detail }) => {
          const count = cart?.totalQuantity ?? detail?.itemCount;
          if (Number.isFinite(Number(count))) renderCartCount(count);
          else queueCartSync();
        })
        .catch(() => queueCartSync());
    }
    queueCartSync(350);
  }

  function updateHeaderHeight() {
    const headerGroup = qs('#header-group');
    const height = headerGroup ? Math.ceil(headerGroup.getBoundingClientRect().height) : 0;
    document.documentElement.style.setProperty('--mm-header-stack-height', `${height}px`);
  }

  function initialiseHeaderMeasurement() {
    updateHeaderHeight();
    const headerGroup = qs('#header-group');
    if (headerGroup && 'ResizeObserver' in window) {
      const observer = new ResizeObserver(updateHeaderHeight);
      observer.observe(headerGroup);
    }
    window.addEventListener('resize', updateHeaderHeight, { passive: true });
  }

  function initialiseSizeCharts(context = document) {
    qsa('[data-mm-size-chart-dialog]', context).forEach((dialog) => {
      if (dialog.dataset.mmInitialised === 'true') return;
      dialog.dataset.mmInitialised = 'true';
      dialog.addEventListener('close', () => { document.body.style.overflow = ''; });
      dialog.addEventListener('cancel', () => { document.body.style.overflow = ''; });
    });
  }

  initialiseHeroes();
  initialiseHeaderMeasurement();
  initialiseSizeCharts();
  syncCartCount();

  document.addEventListener('shopify:cart:lines-update', handleCartLinesUpdate);
  window.addEventListener('pageshow', queueCartSync);
  document.addEventListener('shopify:section:load', (event) => {
    initialiseHeroes(event.target);
    initialiseSizeCharts(event.target);
    updateHeaderHeight();
    queueCartSync();
  });
  document.addEventListener('shopify:section:reorder', updateHeaderHeight);
  document.addEventListener('shopify:block:select', updateHeaderHeight);
})();
